import { Show, onCleanup, onMount, createUniqueId, type JSX } from "solid-js";

interface ModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: JSX.Element;
}

export function Modal(p: ModalProps) {
  const titleId = createUniqueId();
  const bodyId = createUniqueId();

  const onKey = (e: KeyboardEvent) => {
    if (e.key === "Escape" && p.open) p.onClose();
  };
  onMount(() => {
    window.addEventListener("keydown", onKey);
    onCleanup(() => window.removeEventListener("keydown", onKey));
  });

  const onBackdropClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) p.onClose();
  };

  return (
    <Show when={p.open}>
      <div
        class="fd-modal-backdrop"
        onClick={onBackdropClick}
      >
        <div
          role="alertdialog"
          aria-labelledby={titleId}
          aria-describedby={bodyId}
          class="fd-modal-panel"
        >
          <h2 id={titleId} class="fd-modal-title">{p.title}</h2>
          <div id={bodyId} class="fd-modal-body">{p.children}</div>
          <div class="fd-modal-actions">
            <button
              type="button"
              class="fd-button-primary"
              onClick={() => p.onClose()}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </Show>
  );
}
